export enum CakeLockStatus {
  NotLocked = 'NotLocked',
  Locking = 'Locking',
  Expired = 'Expired',
  Migrate = 'Migrate',
}

export enum CakePoolType {
  NOT_MIGRATED = 0,
  MIGRATED = 1,
  DELEGATED = 2,
}
